<section id="service-dashboard-container">
    <section id='header'>
        <div class='title col-lg-9 cmn-padding-0'>
            <div class='main'>{{ 'navigation.salesSchedule' | translate }}</div>
            <div class="sub-text">{{ 'serviceSchedule.hoursOfOperation' | translate }} {{hoursOfOperation}}</div>            
        </div>
        <div class="col-lg-3" style="padding-top: 1.4rem;text-align: end;">
            <div class="row header-buttons">
                <div class="col-md-2">
                    <button mat-icon-button aria-label="print service dashboard" class="dashboard-outline"
                    (click)="openPrintOverlay()">
                    <asp-icon name='ic-20-communication-print.svg' color="inherit" height="1rem" width="1rem"></asp-icon>
                    </button>
                </div>
                <div class="col-md-2">
                    <button class="dashboard-outline" matBadge={{dashboardOverlayService.badgeCount}}
                        [matBadgeHidden]="dashboardOverlayService.badgeCount===0" 
                        (click)="launchdashboardoverlay()">
                        <asp-icon class="dashboard-icon" name="svg/icondashboard.svg" color="inherit" height="1rem"
                            width="1rem"></asp-icon>
                    </button>
                </div>

                <div class="col-md-2">
                    <button class="refresh-outline" (click)="refresh()">
                        <asp-icon class="refresh-icon" name="ic-20-utility-refresh.svg" color="inherit" height="30px"
                            width="30px"></asp-icon>
                    </button>
            
                </div>
            </div>
        </div> 
    </section>
    <app-splitter class="app-splitter d-block" [config]="'horizontal 100% 0 .4rem'"></app-splitter>
    <app-dashboard-calendar (hoursOfOperationChange)='onHoursOfOperationChange($event)' [refreshTime]='refreshTime' [department]='department'
    (emitAppointmentDetails)="emitAppointmentDetails($event)">
    </app-dashboard-calendar>
</section>